import MenuItem from './menuItem';
import Logo from 'static/img/logo-white.svg';
export default ({ ...props }) => {
	return (
		<div className="">
			<nav id="navbar-main" className="navbar navbar-expand-lg fixed-top bg-primary p-0">
				<div className="container">
					<a className="navbar-brand p-0" href="/">
						<img height="35" src={Logo} />
					</a>
					<button
						className="custom-toggler navbar-toggler collapsed"
						type="button"
						data-toggle="collapse"
						data-target="#navbarCollapse"
						aria-controls="navbarCollapse"
						aria-expanded="false"
						aria-label="Toggle navigation"
					>
						<span className="navbar-toggler-icon" />
					</button>
					<div className="navbar-collapse collapse">
						<MenuItem {...props} />
					</div>
				</div>
			</nav>
			<div className="navbar-collapse collapse bg-primary-t position-fixed w-100" id="navbarCollapse">
				<MenuItem {...props} />
			</div>
			<style jsx>
				{`
					@import './styles/jmto-custom';
					@media (max-width: 991.98px) {
						.container {
							padding-top: 14px !important;
							padding-bottom: 14px !important;
						}
						.navbar-brand {
							margin-left: 15px;
						}
					}

					.bg-primary-t {
						top: 65px;
						background-color: rgba($blue, .9);
						z-index: 10;
					}
					.navbar {
						box-shadow: 0 5px 13px 0 rgba($black, .4);
					}
					.custom-toggler.navbar-toggler {
						border-color: transparent;
						outline: none;
					}
					.custom-toggler .navbar-toggler-icon {
						background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255,1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
					}
				`}
			</style>
		</div>
	);
};
